export default "/images/92ba97c1855f488ebf18ba6116b83ab8.avif";